export default __webpack_public_path__ + "static/media/banner5.d96687c1.jpg";